module.exports = __webpack_public_path__ + "img/img5.f00692f9.png";